import { ImageSourcePropType } from "react-native"

import { CongratType } from "../../features/Navigation/types"

export const images: { [key: string]: ImageSourcePropType } = {
  custom_surgery: require("./custom_surgery.png"),
  kine: require("./kine.png"),
  equipment: require("./equipment.png"),
  logo: require("./welcome1.png"),
  evaluation: require("./evaluation.png"),
  congrat_misession: require("./congrat.png"),
  congrat_session: require("./congrat_session.png"),
  congrat_program: require("./congrat_program.png"),
  congrat_phase: require("./congrat_phase.png"),
  congrat_end: require("./congrat_end.png"),
  surgeon: require("./surgeon.png"),
  oncologist: require("./oncologist.png"),
  kine_patient: require("./kine_patient.png"),
  last_session: require("./last_session.png"),
  gp: require("./gp.png"),
  review: require("./review.png"),
  right_placeholder: require("./right_placeholder.jpg"),
  proms_welcome: require("./proms_welcome.png"),
  proms_end: require("./proms_end.png"),
  orthense: require("./orthense.png"),
  renacot: require("./renacot.png"),
  oneday: require("./oneday.png"),
  follow: require("./follow.png"),
  yooli: require("./yooli.png"),
  logo_ce: require("./logo_ce.png"),
  logo_UDI: require("./logo_UDI.png"),
  logo_medical_device: require("./logo_medical_device.png"),
  logo_manufacturer: require("./logo_manufacturer.png"),
  logo_instruction: require("./logo_instruction.png"),
  logo_manufacture_date: require("./logo_manufacture_date.png"),
  singapore_rep: require("./singapore_rep.png"),
  india_rep: require("./india_rep.png"),
  social_protection: require("./social_protection.png"),
  franceconnect_button: require("./franceconnect_button.png"),
}

export const welcomeImages = [
  require("./welcome1.png"),
  require("./welcome2.png"),
  require("./welcome3.png"),
]

type CongratulationImage = { [K in CongratType]: ImageSourcePropType | ImageSourcePropType[] }
export const congratulationImages: CongratulationImage = {
  [CongratType.session]: images.congrat_session,
  [CongratType.misession]: images.congrat_misession,
  [CongratType.program]: images.congrat_program,
  [CongratType.phase]: images.congrat_phase,
  [CongratType.end]: images.congrat_end,
}
